import reqest from "../common/reqest";




/**
 * 展会列表
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function OrderList(data) {
    return reqest.send("/Pub/Exhibition_OrderList", data, true);
}

/**
 * 招聘岗位
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function selectRecruitPost(data) {
    return reqest.send("/index/findJogClassifyList", data, true);
}

/**
 * 求职意向  招聘岗位
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function updatePostMess(data) {
    return reqest.send("/index/addOrUpdateJob", data, true);
}

/**
 * 删除 求职意向  招聘岗位
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function deletePostMess(data) {
    return reqest.send("/index/deleteJob", data, true);
}

/**
 * 查询学历
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function selectEducation(data) {
    return reqest.send("/index/findEducationList", data, true);
}

/**
 * 首页banner
 */
export function getBanner(data) {
    return reqest.send("/Pub/Index_Banner", data);
}

/**
 * 获取区号数据
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function areaList(data) {
    return reqest.send("/Pub/area", data, true);
}
/**
 * 招聘会列表
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function selectList(data) {
    return reqest.send("/Pub/Exhibition_SelectList", data);
}


/**
 * 首页获取展会列表
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function IndeList(data) {
    return reqest.send("/Pub/getExhibition", data);
}
/**
 * 个人中心嘉宾名单获取可以被查看的展会目录
 * 只显示个人曾经买过票的展会
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function Can_View_Exh_List(data) {
    return reqest.send("/Pub/Exhibition_List", data);
}


/**
 * 展会门票
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function selectTickets(data) {
    return reqest.send("/Pub/Exhibition_Tickets", data);
}


/**
 * 新展会门票
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function exhibitionPayInfo(data) {
    return reqest.send("/Pub/Exhibition_Pay_info", data);
}


/**
 * 直播间分类
 * @returns {Promise<unknown>}
 */
export function getBroadcastClass(data) {
    return reqest.send("/Pub/Broadcast_Class", data, true)
}


/**
 * 直播间
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function SelectBroadcast(data) {
    return reqest.send("/Pub/Broadcast_SelectList", data)
}


/**
 * 直播间人数统计
 * @param data
 * @returns {Promise<unknown>}
 */
export function sumUserNum(data) {
    return reqest.send("/Gateway/bbs_user_num", data)
}

/**
 * 展会详情页观展用户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getDetailLiveUser(data) {
  return reqest.send("/Pub/Detail_Live_User_List", data)
}

/**
 * 展会详情页参展用户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getDetailLiveUserJoinList(data) {
  return reqest.send("/Pub/Detail_Live_User_join_List", data)
}

/**
 * 展会详情页参展用户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getguestsList(data) {
    return reqest.send("/Pub/Detail_List", data)
  }

/**
 * 获取通知列表
 * @param {*} data
 * @param {*} _this
 */
export function noticeList(data) {
   return reqest.send("/Pub/Front_notice_List", data);
}

/**
 * 线下预约
 * @param {*} data
 * @param {*} _this
 */
export function privateTalk(data) {
    return reqest.send("/Pub/privateTalk", data);
 }

/**
 * 获取直播间实时排队数据
 * @param {*} data
 * @param {*} _this
 */
export function liveRoomLine(data) {
    return reqest.send("/Pub/LiveRoomLine", data);
 }



/**
 * 获取PC端分享链接
 * @param {*} data
 * @param {*} _this
 */
export function pcShareLink(data) {
    return reqest.send("/Pub/pcShareLink", data);
 }


/**
 * 查询是否被叫号
 * @param {*} data
 * @param {*} _this
 */
export function isCall(data) {
    return reqest.send("/Pub/isCall", data);
 }


/**
 * 获取进博会信息
 * @param {*} data
 * @param {*} _this
 */
export function bannerUrl(data) {
    return reqest.send("/Login/bannerUrl", data);
 }


 /**
  * 获取进博会信息
  * @param {*} data
  * @param {*} _this
  */
 export function exhReg(data) {
     return reqest.send("/Login/exhReg", data);
  }

 /**
  * 获取进博会展商列表
  * @param {*} data
  * @param {*} _this
  */
 export function getCompanyList(data) {
    return reqest.send("/Jbh/getCompanyList", data);
 }


 /**
  * 获取进博会展商详情
  * @param {*} data
  * @param {*} _this
  */
 export function getCompanyDetail(data) {
    return reqest.send("/Jbh/getCompanyDetail", data);
 }


/**
 * 云展说明分类
 * @param {*} data
 * @param {*} _this
 */
export function getChannel(data) {
    return reqest.send("/Pub/getChannel", data);
}

/**
 * 云展说明分类详情
 * @param {*} data
 * @param {*} _this
 */
export function getChannelConnect(data) {
    return reqest.send("/Pub/getChannelConnect", data);
}
/**
 * 获取未结束的展会
 * @param {*} data
 * @param {*} _this
 */
export function getNotEndExhibition(data) {
    return reqest.send("/Pub/Exhibition_Not_End_List", data);
}
/**
 * 获取直播间列表
 * @param {*} data
 * @param {*} _this
 */
export function getBroadcastList(data) {
    return reqest.send("/Exhibition/get_broadcast_list", data);
}
/**
 * 分页查询参展用户
 * @param {*} data
 * @param {*} _this
 */
export function getExhibitionUser(data) {
    return reqest.send("/Exhibition/get_exhibition_user", data);
}
/**
 * 查询我购票数量
 * @param {*} data
 * @param {*} _this
 */
export function getExhibitionUserCount(data) {
    return reqest.send("/Exhibition/get_exhibition_user_count", data);
}
/**
 * 分页查询展商
 * @param {*} data
 * @param {*} _this
 */
export function getCompanysList(data) {
    return reqest.send("/Exhibition/get_companys_list", data);
}
/**
 * 查询展商详情
 * @param {*} data
 * @param {*} _this
 */
export function getCompanysDetails(data) {
    return reqest.send("/Exhibition/get_companys_details", data);
}

/**
 * 获取直播间预约列表
 * @param {*} data
 * @param {*} _this
 */
export function getBroadcastSubList(data) {
    return reqest.send("/Exhibition/get_broadcast_sub_list", data);
}
/**
 * 导出直播间预约列表
 * @param {*} data
 * @param {*} _this
 */
export function excelBroadcastSub(data) {
    return reqest.export("/Exhibition/excel_broadcast_sub", data);
}
/**
 * 取消直播间预约
 * @param {*} data
 * @param {*} _this
 */
export function cancelBroadcastSubscribe(data) {
    return reqest.send("/Exhibition/cancel_broadcast_subscribe", data);
}
/**
 * 直播间暂停或开始
 * @param {*} data status 1 表示未暂停, 2表示暂停
 * @param {*} _this
 */
export function broadcastPauseOrStart(data) {
    return reqest.send("/Live/broadcast_pause_or_start", data);
}
/**
 * 邀请新用户前检查
 */
export function invitationInspect(data) {
    return reqest.send("/Live/invitation_inspect", data);
}
/**
 * 邀请新用户前检查
 */
export function invitationNewUser(data) {
    return reqest.send("/Live/invitation_new_user", data);
}
/**
 * 添加用户面试备注
 */
export function addUserInterviewRemarks(data) {
    return reqest.send("/Live/addUserInterviewRemarks", data);
}
/**
 * 拒绝用户面试
 */
export function refuseUserInterview(data) {
    return reqest.send("/Live/refuseUserInterview", data);
}
/**
 * 查询用户面试记录
 */
export function findUserInterview(data) {
    return reqest.send("/Live/findUserInterview", data);
}
/**
 * 查询展会频道
 */
export function getExhibitionChannel(data) {
    return reqest.send("/Exhibition/get_exhibition_channel", data);
}

/**
 * 查询展会频道
 */
export function getExhibitionInfo(data) {
    return reqest.send("/Exhibition/get_exhibition_info", data);
}
/**
 * 获取使用资源
 */
export function getResocuseUse(data) {
    return reqest.send("/Pub/get_resocuse_use", data);
}
/**
 * 获取支付的展会
 */
export function getExhibitionSelectListApplet(data) {
    return reqest.send("/Pub/Exhibition_SelectList_Applet", data);
}
/**
 * 获取各个展会的通知信息
 */
export function getNoticeAll(data) {
    return reqest.send("/notice/get_notice_all", data);
}
/**
 * 发送洽谈提醒短信
 */
export function sendNegotiateSms(data) {
    return reqest.send("/Login/sendNegotiateSms", data);
}
export function getRechargeAdvertising(data) {
    return reqest.send("/Wxapplet/get_recharge_advertising", data);
}
/**
 * 直播间字幕翻译
 */
export function subtitleTranslation(data) {
    return reqest.send("/Live/subtitleTranslation", data);
}

/**
 * 招聘会岗位数量
 * @param {*} data
 * @param {*} _this
 */
export function getJobFairNum(data) {
    return reqest.send("/index/findExhibitionJobCount", data);
}



